import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IProducts } from '../models/products.model';

export const pendingProductsFromSomeoneElseFeatureKey = 'pendingProductsFromSomeoneElse';

export interface PendingProductsFromSomeoneElseState {
  loadPendingProductsFromSomeoneElseResponse: IProducts[];
  loadPendingProductsFromSomeoneElseFailure: Error | any;
}

export const initialState: PendingProductsFromSomeoneElseState = {
  loadPendingProductsFromSomeoneElseResponse: undefined,
  loadPendingProductsFromSomeoneElseFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadPendingProductsFromSomeoneElse, (state, action) => ({
    ...state
  })),
  on(actions.loadPendingProductsFromSomeoneElseSuccess, (state, action) => ({
    ...state,
    loadPendingProductsFromSomeoneElseResponse: action.response
  })),
  on(actions.loadPendingProductsFromSomeoneElseFailure, (state, action) => ({
    ...state,
    loadPendingProductsFromSomeoneElseFailure: action.error
  }))
);

export const getPendingProductsFromSomeoneElseResponse = (state: PendingProductsFromSomeoneElseState) =>
  state.loadPendingProductsFromSomeoneElseResponse;
